import PatternForm from "../../components/Forms/PatternForm/PatternForm";

export default function NewPatternPage() {
    return (
        <PatternForm method="POST" />
    );
}